// next
import { Divider } from 'antd';

export default function NextDivider() {

  return (
  <>
    <Divider />
  </>
  )
}